<template>
    <div class="section_fiche_pc_course">
        <h5>Infos PC Course</h5>
        <b-row>
            <b-col>
                <h6>Identité du coureur</h6>
                <p><b>Nom - Prénom</b>: {{ runner.identite.nom }} {{ runner.identite.prenom }}</p>
                <p>
                    <b>Sexe</b>:
                    <span v-if="runner.identite.sexe == 'M'">Homme</span>
                    <span v-else-if="runner.identite.sexe == 'F'">Femme</span>
                    <span v-else>Non renseigné</span>
                </p>
                <p>
                    <b>Année de naissance</b>: <span
                        v-if="runner.identite.naissance_complet && runner.identite.naissance_complet != ''">{{
                            runner.identite.naissance_complet
                        }}</span>
                    <span v-else-if="runner.identite.naissance && runner.identite.naissance != ''">{{
                        runner.identite.naissance }}</span>
                    <span v-else>Non renseigné</span>
                </p>

                <p>
                    <b>Nationalité</b>: <span v-if="runner.identite.nation && runner.identite.nation != ''">{{
                        runner.identite.nation
                        }}</span><span v-else>Non renseigné</span>
                </p>
                <p>
                    <b>Club</b>: <span v-if="runner.identite.club && runner.identite.club != ''">{{ runner.identite.club
                        }}</span><span v-else>Non renseigné</span>
                </p>
                <p>
                    <b>ROAG</b>: <span v-if="runner.identite.roag && runner.identite.roag != ''">{{ runner.identite.roag
                    }}</span><span v-else>Non renseigné</span>
                </p>
            </b-col>
            <b-col>
                <h6>Informations de contact</h6>
                <p>
                    <b>Tel du coureur</b>: <span v-if="runner.identite.tel && runner.identite.tel != ''">{{
                        runner.identite.tel }}</span><span v-else>Non renseigné</span>
                </p>
                <p>
                    <b>Personne à contacter en cas d'urgence</b> : <span
                        v-if="runner.identite.contact_urgence && runner.identite.contact_urgence != ''">{{
                            runner.identite.contact_urgence
                        }}</span><span v-else>Non renseigné</span>
                </p>
                <p>
                    <b>Téléphone à contacter en cas d'urgence</b> : <span
                        v-if="runner.identite.tel_contact_urgence && runner.identite.tel_contact_urgence != ''">{{
                            runner.identite.tel_contact_urgence }}</span><span v-else>Non renseigné</span>
                </p>
            </b-col>
            <b-col>
                <h6>Statut de course</h6>
                <p v-if="runner.statut_course.heure_depart"><b>Départ</b>: {{ runner.statut_course.heure_depart }}</p>

                <p>
                    <b>Statut</b>: <span v-if="runner.statut.text && runner.statut.text != ''">{{ runner.statut.text
                    }}</span>
                </p>

                <p v-if="runner.statut_course.heure_depart && !runner.statut.arrivee && runner.estimation">
                    <b>Distance parcourue estimée</b>: <span
                        v-if="runner.estimation.distance != '' && !isNaN(runner.estimation.distance)">{{
                            Number(runner.estimation.distance).toFixed(1) }}km</span>
                </p>
            </b-col>
        </b-row>
        <hr />

        <SectionLocalisationUrgence :coureur="runner.identite"></SectionLocalisationUrgence>
        <hr />
        <SectionStatutCoureur :coureur="runner" @statut-coureur-changed="$emit('statut-coureur-changed')">
        </SectionStatutCoureur>
        <hr />
        <ExtraInfosCoureur :coureur="runner"></ExtraInfosCoureur>
    </div>
</template>

<script>
import SectionLocalisationUrgence from "../Live_tab/PCCourse/SectionLocalisationUrgence.vue";
import SectionStatutCoureur from "../Live_tab/PCCourse/SectionStatutCoureur.vue";
import ExtraInfosCoureur from "../Live_tab/PCCourse/ExtraInfosCoureur.vue";
export default {
    props: ["runner"],
    components: {
        SectionLocalisationUrgence,
        SectionStatutCoureur,
        ExtraInfosCoureur,
    },
};
</script>

<style lang="scss" scoped></style>